import { Helmet } from "react-helmet-async";

const SITE_BASE = "https://puravidatuxpan.com";
const DEFAULT_OG_IMAGE = "https://customer-assets.emergentagent.com/job_playas-veracruz/artifacts/9zic33cw_a8ddb780-66a3-4fbe-b8df-ff87c066511a.jpg";

// Google Search Console verification token.
// To activate: add REACT_APP_GOOGLE_SITE_VERIFICATION=... to /app/frontend/.env
// (value comes from Search Console > HTML tag method, only the "content"
// attribute of the proposed <meta name="google-site-verification" ...> tag).
const GSC_TOKEN = process.env.REACT_APP_GOOGLE_SITE_VERIFICATION || "";
// Bing Webmaster Tools (optional — same mechanism).
const BING_TOKEN = process.env.REACT_APP_BING_SITE_VERIFICATION || "";

/**
 * PageSEO — sets <title>, meta description, canonical, Open Graph
 * and Twitter Card tags per page. Also emits JSON-LD structured data
 * when `structuredData` is provided.
 */
export default function PageSEO({
  title,
  description,
  path = "/",
  image = DEFAULT_OG_IMAGE,
  imageAlt,
  type = "website",
  keywords,
  structuredData,
}) {
  const url = `${SITE_BASE}${path}`;
  const fullTitle = title.includes("Villas Pura Vida") ? title : `${title} · Villas Pura Vida`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />

      {/* Search engines verification (homepage/every page safe — picked up once) */}
      {GSC_TOKEN && <meta name="google-site-verification" content={GSC_TOKEN} />}
      {BING_TOKEN && <meta name="msvalidate.01" content={BING_TOKEN} />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Villas Pura Vida" />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      {imageAlt && <meta property="og:image:alt" content={imageAlt} />}
      <meta property="og:locale" content="es_MX" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={image} />
      {imageAlt && <meta name="twitter:image:alt" content={imageAlt} />}

      {/* JSON-LD structured data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
}
